import { createAction, props } from '@ngrx/store';
import { NotificationToast } from '../interfaces/NotificationToast.interface';

export const onNotificationTriggered = createAction(
    '[Aumico-Core] onNotificationTriggered',
    props<{ payload: NotificationToast }>(),
);

export const onNotificationClosed = createAction('[Aumico-Core] onNotificationClosed', props<{ payload: string }>());
